export let ShippingMethod = /*#__PURE__*/function (ShippingMethod) {
  ShippingMethod["DELIVERY"] = "delivery";
  ShippingMethod["PICKUP"] = "pickup";
  ShippingMethod["VAULT"] = "vault";
  return ShippingMethod;
}({});
export let PaymentMethod = /*#__PURE__*/function (PaymentMethod) {
  PaymentMethod["VIETQR"] = "vietqr";
  PaymentMethod["IN_STORE"] = "in_store";
  PaymentMethod["VIETTINBANK"] = "viettinbank";
  PaymentMethod["CASH"] = "cash";
  PaymentMethod["BANK"] = "bank";
  return PaymentMethod;
}({});
export let PaymentState = /*#__PURE__*/function (PaymentState) {
  PaymentState["PENDING"] = "PENDING";
  PaymentState["PAID"] = "PAID";
  PaymentState["PARTIAL_PAID"] = "PARTIAL_PAID";
  PaymentState["UNPAID"] = "UNPAID";
  PaymentState["FAILED"] = "FAILED";
  PaymentState["EXPIRED"] = "EXPIRED";
  PaymentState["REFUNDED"] = "REFUNDED";
  return PaymentState;
}({});
export let OrderState = /*#__PURE__*/function (OrderState) {
  OrderState["DRAFT"] = "DRAFT";
  OrderState["PENDING"] = "PENDING";
  OrderState["WAIT_PAYMENT"] = "WAIT_PAYMENT";
  OrderState["PAID"] = "PAID";
  OrderState["PARTIAL_PAID"] = "PARTIAL_PAID";
  OrderState["CONFIRMED"] = "CONFIRMED";
  OrderState["DELIVERING"] = "DELIVERING";
  OrderState["COMPLETED"] = "COMPLETED";
  OrderState["CANCELED"] = "CANCELED";
  OrderState["RETURNED"] = "RETURNED";
  // Deprecated — giữ để tương thích dữ liệu cũ
  OrderState["CUSTOMER_CARE_CONFIRMED"] = "CUSTOMER_CARE_CONFIRMED";
  OrderState["WAITING_INVOICE"] = "WAITING_INVOICE";
  OrderState["INVOICE_ISSUED"] = "INVOICE_ISSUED";
  OrderState["PROCESSING"] = "PROCESSING";
  OrderState["UNPAID"] = "UNPAID";
  OrderState["WAITING_PICKUP"] = "WAITING_PICKUP";
  OrderState["REFUNDED"] = "REFUNDED";
  OrderState["DELIVER_FAILED"] = "DELIVER_FAILED";
  // History-only
  OrderState["PENDING_PAYMENT"] = "PENDING_PAYMENT";
  OrderState["PAID_PAYMENT"] = "PAID_PAYMENT";
  OrderState["UNPAID_PAYMENT"] = "UNPAID_PAYMENT";
  OrderState["FAILED_PAYMENT"] = "FAILED_PAYMENT";
  OrderState["EXPIRED_PAYMENT"] = "EXPIRED_PAYMENT";
  return OrderState;
}({});
export let InvoiceState = /*#__PURE__*/function (InvoiceState) {
  InvoiceState["NONE"] = "NONE";
  InvoiceState["WAITING"] = "WAITING";
  InvoiceState["ISSUED"] = "ISSUED";
  return InvoiceState;
}({});
export let OrderChannel = /*#__PURE__*/function (OrderChannel) {
  OrderChannel["BIDV"] = "BIDV";
  OrderChannel["WEB"] = "WEB";
  OrderChannel["POS"] = "POS";
  OrderChannel["APP"] = "APP";
  OrderChannel["ZALO"] = "ZALO";
  OrderChannel["FACEBOOK"] = "FACEBOOK";
  OrderChannel["TIKTOK"] = "TIKTOK";
  OrderChannel["SHOPEE"] = "SHOPEE";
  OrderChannel["OTHER"] = "OTHER";
  OrderChannel["BO"] = "BO";
  OrderChannel["DEALER_PORTAL"] = "DEALER_PORTAL";
  return OrderChannel;
}({});
export let FulfillmentType = /*#__PURE__*/function (FulfillmentType) {
  FulfillmentType["INSTANT"] = "INSTANT";
  FulfillmentType["PREORDER"] = "PREORDER";
  return FulfillmentType;
}({});
export let ShippingState = /*#__PURE__*/function (ShippingState) {
  ShippingState["IDLE"] = "IDLE";
  ShippingState["ASSIGNING"] = "ASSIGNING";
  ShippingState["ACCEPTED"] = "ACCEPTED";
  ShippingState["IN_PROCESS"] = "IN_PROCESS";
  ShippingState["COMPLETED"] = "COMPLETED";
  ShippingState["CANCELLED"] = "CANCELLED";
  return ShippingState;
}({});
export let ShippingPartnerName = /*#__PURE__*/function (ShippingPartnerName) {
  ShippingPartnerName["AHAMOVE"] = "AHAMOVE";
  ShippingPartnerName["MANUAL"] = "MANUAL";
  ShippingPartnerName["VIETTELPOST"] = "VIETTELPOST";
  ShippingPartnerName["GHTK"] = "GHTK";
  return ShippingPartnerName;
}({});
export let Platform = /*#__PURE__*/function (Platform) {
  Platform["ONLINE"] = "online";
  Platform["OFFLINE"] = "offline";
  Platform["ADMIN"] = "admin";
  return Platform;
}({});
export const pendingOrderStates = [OrderState.PENDING, OrderState.WAIT_PAYMENT, OrderState.PAID, OrderState.PARTIAL_PAID, OrderState.CONFIRMED];
//# sourceMappingURL=order.enum.js.map